import { ReportsApiResponse } from '../types';
import { createSlice } from '@reduxjs/toolkit';

const initialState : ReportsApiResponse["data"] = {
	page: "1",
	maxPage: "1",
	reports: []
};

const reportsSlice = createSlice({
	name: 'reports',
	initialState: initialState,
	reducers: {
		setReportsData: (state, action) => action.payload,
		reset: (state, action) => initialState,
	},
});

export const { setReportsData, reset } = reportsSlice.actions;

export default reportsSlice.reducer;